export const SEARCH_PALETTE_EVENT = "open-search-palette";

export function openSearchPalette() {
  window.dispatchEvent(new CustomEvent(SEARCH_PALETTE_EVENT));
}
